<template lang="pug" src="./medium.pug"></template>

<script>
import pinia from '@/pinia';
import { useShopArticleStore } from '@/stores';

import ProductMedium from './ProductMedium';

export default {
    name: 'ArticleMedium',
    extends: ProductMedium,
    computed: {
        shopArticleStore() {
            return useShopArticleStore(pinia);
        }
    },
    methods: {
        updateMediaVisibility(payload) {
            this.shopArticleStore.updateFormMediaVisibility(payload);
        },
        updateMediaVideoAi(payload) {
            this.shopArticleStore.updateFormMediaVideoAi(payload);
        },
        markMediaAsDeleted(index) {
            this.shopArticleStore.markFormMediaAsDeleted(index);
        },
        unmarkMediaAsDeleted(index) {
            this.shopArticleStore.unmarkFormMediaAsDeleted(index);
        }
    }
};
</script>
